module.exports = __webpack_public_path__ + "img/enemy_move_down.d47f3ff3.svg";